import _styled from 'styled-components';
import React, { useRef, useState, useCallback, useEffect, useLayoutEffect } from 'react';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var _templateObject;

var SlideStyles = _styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  transition: transform 0.2s ease-out;\n  div {\n    padding: 1rem;\n    height: 100%;\n    width: ", ";\n    height: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    user-select: none;\n  }\n  img {\n    max-width: 100%;\n    max-height: 100%;\n  }\n"])), function (props) {
  return props.sliderWidth;
}, function (props) {
  return props.sliderHeight;
});

function Slide(_ref) {
  var child = _ref.child,
      sliderWidth = _ref.sliderWidth,
      sliderHeight = _ref.sliderHeight,
      _ref$scaleOnDrag = _ref.scaleOnDrag,
      scaleOnDrag = _ref$scaleOnDrag === void 0 ? false : _ref$scaleOnDrag;
  var slideRef = useRef('slide');

  var onMouseDown = function onMouseDown() {
    if (scaleOnDrag) slideRef.current.style.transform = 'scale(0.9)';
  };

  var onMouseUp = function onMouseUp() {
    if (scaleOnDrag) slideRef.current.style.transform = 'scale(1)';
  };

  return /*#__PURE__*/React.createElement(SlideStyles, {
    ref: slideRef,
    sliderWidth: sliderWidth + "px",
    sliderHeight: sliderHeight + "px",
    className: "SlideStyles"
  }, /*#__PURE__*/React.createElement("div", {
    unselectable: "on",
    className: "slide-inner",
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchStart: onMouseDown,
    onTouchEnd: onMouseUp,
    onMouseLeave: onMouseUp,
    onDragStart: function onDragStart(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, child));
}

function getPositionX(event) {
  return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
}

function getElementDimensions(ref) {
  var width = ref.current.clientWidth;
  var height = ref.current.clientHeight;
  return {
    width: width,
    height: height
  };
}

var _templateObject$1, _templateObject2;

var SliderStyles = _styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  all: initial;\n  width: 100%;\n  height: 100%;\n  max-height: 100vh;\n  display: inline-flex;\n  will-change: transform, scale;\n  cursor: grab;\n  .slide-outer {\n    display: flex;\n    align-items: center;\n  }\n"])));

var SliderWrapper = _styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  max-height: 100vh;\n"])));

function Slider(_ref) {
  var children = _ref.children,
      onSlideComplete = _ref.onSlideComplete,
      onSlideStart = _ref.onSlideStart,
      _ref$activeIndex = _ref.activeIndex,
      activeIndex = _ref$activeIndex === void 0 ? null : _ref$activeIndex,
      _ref$threshHold = _ref.threshHold,
      threshHold = _ref$threshHold === void 0 ? 100 : _ref$threshHold,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? 0.3 : _ref$transition,
      _ref$scaleOnDrag = _ref.scaleOnDrag,
      scaleOnDrag = _ref$scaleOnDrag === void 0 ? false : _ref$scaleOnDrag;

  var _useState = useState({
    width: 0,
    height: 0
  }),
      dimensions = _useState[0],
      setDimensions = _useState[1];

  var dragging = useRef(false);
  var startPos = useRef(0);
  var currentTranslate = useRef(0);
  var prevTranslate = useRef(0);
  var currentIndex = useRef(activeIndex || 0);
  var sliderRef = useRef('slider');
  var animationRef = useRef(null);
  var setPositionByIndex = useCallback(function (w) {
    if (w === void 0) {
      w = dimensions.width;
    }

    currentTranslate.current = currentIndex.current * -w;
    prevTranslate.current = currentTranslate.current;
    setSliderPosition();
  }, [dimensions.width]);

  var transitionOn = function transitionOn() {
    return sliderRef.current.style.transition = "transform " + transition + "s ease-out";
  };

  var transitionOff = function transitionOff() {
    return sliderRef.current.style.transition = 'none';
  };

  useEffect(function () {
    if (activeIndex !== currentIndex.current) {
      transitionOn();
      currentIndex.current = activeIndex;
      setPositionByIndex();
    }
  }, [activeIndex, setPositionByIndex]);
  useLayoutEffect(function () {
    setDimensions(getElementDimensions(sliderRef));
    setPositionByIndex(getElementDimensions(sliderRef).width);
  }, [setPositionByIndex]);
  useEffect(function () {
    var handleResize = function handleResize() {
      transitionOff();

      var _getElementDimensions = getElementDimensions(sliderRef),
          width = _getElementDimensions.width,
          height = _getElementDimensions.height;

      setDimensions({
        width: width,
        height: height
      });
      setPositionByIndex(width);
    };

    var handleKeyDown = function handleKeyDown(_ref2) {
      var key = _ref2.key;
      var arrowsPressed = ['ArrowRight', 'ArrowLeft'].includes(key);
      if (arrowsPressed) transitionOn();

      if (arrowsPressed && onSlideStart) {
        onSlideStart(currentIndex.current);
      }

      if (key === 'ArrowRight' && currentIndex.current < children.length - 1) {
        currentIndex.current += 1;
      }

      if (key === 'ArrowLeft' && currentIndex.current > 0) {
        currentIndex.current -= 1;
      }

      if (arrowsPressed && onSlideComplete) onSlideComplete(currentIndex.current);
      setPositionByIndex();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [children.length, setPositionByIndex, onSlideComplete, onSlideStart]);

  function touchStart(index) {
    return function (event) {
      transitionOn();
      currentIndex.current = index;
      startPos.current = getPositionX(event);
      dragging.current = true;
      animationRef.current = requestAnimationFrame(animation);
      sliderRef.current.style.cursor = 'grabbing';
      if (onSlideStart) onSlideStart(currentIndex.current);
    };
  }

  function touchMove(event) {
    if (dragging.current) {
      var currentPosition = getPositionX(event);
      currentTranslate.current = prevTranslate.current + currentPosition - startPos.current;
    }
  }

  function touchEnd() {
    transitionOn();
    cancelAnimationFrame(animationRef.current);
    dragging.current = false;
    var movedBy = currentTranslate.current - prevTranslate.current;
    if (movedBy < -threshHold && currentIndex.current < children.length - 1) currentIndex.current += 1;
    if (movedBy > threshHold && currentIndex.current > 0) currentIndex.current -= 1;
    transitionOn();
    setPositionByIndex();
    sliderRef.current.style.cursor = 'grab';
    if (onSlideComplete) onSlideComplete(currentIndex.current);
  }

  function animation() {
    setSliderPosition();
    if (dragging.current) requestAnimationFrame(animation);
  }

  function setSliderPosition() {
    sliderRef.current.style.transform = "translateX(" + currentTranslate.current + "px)";
  }

  return /*#__PURE__*/React.createElement(SliderWrapper, {
    className: "SliderWrapper"
  }, /*#__PURE__*/React.createElement(SliderStyles, {
    ref: sliderRef,
    className: "SliderStyles"
  }, children.map(function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: child.key,
      onTouchStart: touchStart(index),
      onMouseDown: touchStart(index),
      onTouchMove: touchMove,
      onMouseMove: touchMove,
      onTouchEnd: touchEnd,
      onMouseUp: touchEnd,
      onMouseLeave: function onMouseLeave() {
        if (dragging.current) touchEnd();
      },
      onContextMenu: function onContextMenu(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      className: "slide-outer"
    }, /*#__PURE__*/React.createElement(Slide, {
      child: child,
      sliderWidth: dimensions.width,
      sliderHeight: dimensions.height,
      scaleOnDrag: scaleOnDrag
    }));
  })));
}

export default Slider;